// Components
import { Button, Error, Spinner } from '@tracklib/kit'

// Selectors
import { useRequest } from 'modules/requests/hooks'

// Utils
import styles from './thankyou.css'

const ThankYou = () => {
  const { isLoading, hasError } = useRequest('POST_SURVEY_DATA')

  if (isLoading) {
    return <Spinner />
  } else if (hasError) {
    return <Error message="Sorry! Something went wrong" subtitle="We will fix this ASAP! Please try again soon" />
  }

  return (
    <div className={styles.thankyouWrapper}>
      <div className={styles.smileyFaceWrapper}>
        <img src="/static/images/interestform/smiley-face.svg" alt="Smiley face" />
      </div>
      <h1 className={styles.heading}>Thanks for your interest!</h1>
      <div className={styles.textContent}>Thank you for showing interest in getting your music on Tracklib! We will be in touch soon</div>
      <Button to="/">Dig for samples on Tracklib</Button>
    </div>
  )
}

export default ThankYou
